module.exports = __webpack_public_path__ + "img/activation-type-blocked.dd2cd3af.svg";